// Praxis design tokens + the `.praxis` scope root (WEB-8000, orig. WEB-5972).
// Every `--pr-*` var is defined here; feature fragments assume this is
// composed BEFORE them (the @import must stay first for fonts to load).
//
// The vars are ALSO defined on `[data-ai-tokens]` (WEB-8001): Radix portals
// (sheets, dropdowns, tooltips) mount on ShadcnScope's shadow-root container,
// which is OUTSIDE `.praxis` — without this the vars collapse there. The
// zero-specificity `:where()` keeps every existing override winning exactly
// as before. Non-var props (typography, background) stay on `.praxis` only.
const praxisTokens = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500&family=Source+Serif+4:ital,wght@0,400;0,500;0,600;1,400;1,500&display=swap');

/* Keep scrolling inside the assistant drawer from chaining into the
   underlying page/app once a scroll container hits its top or bottom. */
.praxis,
.praxis [data-radix-scroll-area-viewport],
.praxis .pr-settings-wrap,
.praxis .pr-sidebar,
.praxis .pr-chat-main { overscroll-behavior: contain; }

:where(.praxis, [data-ai-tokens]) {
  /* Paper + ink — warm neutral, slightly softer than pure grey */
  --pr-bg: oklch(0.985 0.003 250);
  --pr-surface: oklch(1 0 0);
  --pr-surface-2: oklch(0.975 0.004 250);
  --pr-surface-3: oklch(0.955 0.005 250);
  --pr-surface-4: oklch(0.92 0.006 250);

  --pr-ink: oklch(0.22 0.012 250);
  --pr-ink-2: oklch(0.36 0.012 250);
  --pr-ink-3: oklch(0.50 0.010 250);
  --pr-ink-4: oklch(0.62 0.010 250);
  --pr-ink-5: oklch(0.78 0.006 250);

  --pr-border: oklch(0.90 0.005 250);
  --pr-border-2: oklch(0.82 0.006 250);
  --pr-hairline: oklch(0.92 0.005 250);

  /* Muted professional navy accent */
  --pr-accent: oklch(0.42 0.11 245);
  --pr-accent-hover: oklch(0.36 0.12 245);
  --pr-accent-ink: oklch(0.42 0.11 245);
  --pr-accent-soft: oklch(0.975 0.008 245);
  --pr-accent-soft-2: oklch(0.945 0.015 245);

  --pr-success: oklch(0.55 0.12 155);
  --pr-success-soft: oklch(0.96 0.025 155);
  --pr-warn: oklch(0.68 0.14 75);
  --pr-warn-soft: oklch(0.965 0.04 75);
  --pr-danger: oklch(0.58 0.18 25);
  --pr-danger-soft: oklch(0.96 0.03 25);

  --pr-shadow-sm: 0 1px 2px oklch(0.22 0.012 250 / 0.06);
  --pr-shadow-md: 0 4px 12px oklch(0.22 0.012 250 / 0.06), 0 1px 2px oklch(0.22 0.012 250 / 0.04);
  --pr-shadow-lg: 0 24px 48px -20px oklch(0.22 0.012 250 / 0.20), 0 2px 6px oklch(0.22 0.012 250 / 0.06);

  --pr-font-serif: "Source Serif 4", Georgia, "Times New Roman", serif;
  --pr-font-ui: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  --pr-font-mono: "JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, monospace;

  --pr-r-sm: 6px;
  --pr-r-md: 10px;
  --pr-r-lg: 14px;
}

.praxis {
  font-family: var(--pr-font-ui);
  font-feature-settings: "ss01", "cv11";
  color: var(--pr-ink);
  background: var(--pr-surface);
}
`;

export default praxisTokens;
